import React from 'react';
import { countries } from 'countries-list';
import { TextField } from 'formik-mui';
import { FastField } from 'formik';
import { MenuItem } from '@mui/material';
const SelectCountry = React.memo((props) => {
  return (
    <FastField
      {...props}
      component={TextField}
      fullWidth
      select
      variant="outlined">
      {Object.values(countries).map((c) => {
        // some countries have more than 1 code - getting the first only
        const phone = c.phone.split(',')[0];

        return (
          <MenuItem key={c.name} value={phone}>
            {c.name} {'+' + phone} {' ' + c.emoji}
          </MenuItem>
        );
      })}
    </FastField>
  );
});

export default SelectCountry;
